export const USERDATA_CREATE_RESET = 'USERDATA_CREATE_RESET'
export const USERDATA_CREATE_SET_CREATED = 'USERDATA_CREATE_SET_CREATED'
export const USERDATA_CREATE_SET_ERROR = 'USERDATA_CREATE_SET_ERROR'
export const USERDATA_CREATE_SET_VIOLATIONS = 'USERDATA_CREATE_SET_VIOLATIONS'
export const USERDATA_CREATE_TOGGLE_LOADING = 'USERDATA_CREATE_TOGGLE_LOADING'
